import { createFileRoute } from '@tanstack/react-router'
import { AuthProvider } from '../../common/auth/src'
import { RbacProvider } from '../../common/rbac/src'
import { AppLayout } from '../layout/AppLayout'

// Pathless layout route (leading `_`, excluded from the URL) — the ONLY
// place keycloak-js gets initialized (via AuthProvider below). Everything
// nested under `_authenticated/` requires a Keycloak session; __root.tsx
// and /report (MEC-3249) stay outside this subtree and remain fully public.
export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <AuthProvider>
      <RbacProvider>
        <AppLayout />
      </RbacProvider>
    </AuthProvider>
  )
}
